// src/components/common/contentloader/LoadBalancerSkeleton.jsx
import { Box, Card } from "@mui/material";
import { keyframes } from "@mui/system";

const shimmer = keyframes`
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
`;

const Sk = ({ w, h = 12, br = 6, mb = 0 }) => (
  <Box sx={{
    width: w, height: h, borderRadius: `${br}px`, mb: mb ? `${mb}px` : 0, flexShrink: 0,
    background: "linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%)",
    backgroundSize: "600px 100%",
    animation: `${shimmer} 1.4s infinite`,
  }} />
);

const SkCard = ({ children, sx = {} }) => (
  <Card sx={{ border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgb(0 0 0/0.06)", ...sx }}>
    <Box sx={{ p: "18px 20px" }}>{children}</Box>
  </Card>
);

const TableRow = ({ widths, last = false }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: "14px 18px", borderBottom: last ? "none" : "1px solid #f1f5f9" }}>
    <Sk w={36} h={36} br={9} />
    <Box sx={{ flex: 1 }}>
      <Sk w={widths[0]} mb={6} />
      <Sk w={widths[1]} h={10} />
    </Box>
    <Sk w={80} />
    <Sk w={50} h={18} br={20} />
    <Box sx={{ flex: 1 }}>
      <Sk w="100%" h={11} mb={4} />
      <Sk w={80} h={10} />
    </Box>
    <Sk w={60} />
  </Box>
);

export default function LoadBalancerSkeleton() {
  return (
    <Box sx={{ p: 3, bgcolor: "#f5f7fa" }}>

      {/* Header */}
      <SkCard sx={{ mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Sk w={46} h={46} br={12} />
          <Box><Sk w={220} h={16} mb={8} /><Sk w={130} /></Box>
        </Box>
      </SkCard>

      {/* Stat cards */}
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 1.5, mb: 2 }}>
        {[[100, 50], [80, 60], [110, 45]].map(([lw, vw], i) => (
          <SkCard key={i}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <Box><Sk w={lw} mb={10} /><Sk w={vw} h={24} /></Box>
              <Sk w={40} h={40} br={10} />
            </Box>
          </SkCard>
        ))}
      </Box>

      {/* Table */}
      <Card sx={{ border: "1px solid #e2e8f0", p: 0, overflow: "hidden" }}>
        <Box sx={{ display: "flex", gap: 3, p: "10px 18px", borderBottom: "1px solid #e2e8f0" }}>
          {[100, 70, 60, 120, 80].map((w, i) => <Sk key={i} w={w} h={10} />)}
        </Box>
        <TableRow widths={[160, 100]} />
        <TableRow widths={[140, 90]} />
        <TableRow widths={[170, 110]} last />
      </Card>
    </Box>
  );
}